// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__36Tps","box":"WorkspacesBox_box__2cS-O","node":"WorkspacesBox_node__2g-y5"};